module.exports = __webpack_public_path__ + "img/course_video_play.c6e7334e.png";